// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"MobileTabs_tabsWrapper__hbuLO","noTabs":"MobileTabs_noTabs__2sJ4I"};